<template>
    <div class="liveEventContent">
        <div class="container">
            <div class="liveEvent">
                <h3>Hey, Jane. Great to see you. Welcome to TONE Live!</h3>
                <div class="row">
                    <div class="col-md-8 col-md-offset-2">
                        <div  class="embed-responsive embed-responsive-16by9">
                        <iframe title="TONE video player" :src="jwEventRef" frameborder="0" scrolling="auto" allowfullscreen class="embed-responsive-item" ></iframe>
                        </div>
                        <!--<button id="submit_question_btn"
                                type="button"
                                @click="submitQuestion = true"
                                :class="{ 'enabled-submission': submitQuestion }">
                            Submit a question
                        </button>-->
                        <iframe title="Live event chat" width="100%" height="220" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" allowtransparency="true" :src="chatRollURL"></iframe>
                        <div class="attendees">
                            <div class="attendeesContent">
                                <h2>attendees</h2>
                                <div class="liveEventImage">
                                    <!--/////////////////////////// slider start here ////////////////////////////-->
                                    <div class="slider responsive-slick-slider-live" v-if="eventUsersArray">
                                        <div class="sliderBox"  v-for="userList in eventUsersArray">
                                            <div class="liveImage" v-if="userList[0]">
                                                <div v-if="userList[0].isAnonymous === '0'">
                                                    <img :src="userList[0].picture" alt="USER-SHOE" :title="userList[0].firstName">
                                                    <span>{{userList[0].firstName}}</span>
                                                </div>
                                                <div v-else>
                                                    <img :src="userList[0].picture" alt="USER-SHOE" title="Shoe-cognito">
                                                    <span>Shoe-cognito</span>
                                                    <!--<img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/>-->
                                                    <!--<span>Anonymous</span>-->
                                                </div>
                                            </div>
                                            <div class="liveImage" v-if="userList[1]">
                                                <div v-if="userList[1].isAnonymous === '0'">
                                                    <img :src="userList[1].picture" alt="USER-SHOE" :title="userList[1].firstName">
                                                    <span>{{userList[1].firstName}}</span>
                                                </div>
                                                <div v-else>
                                                    <img :src="userList[1].picture" alt="USER-SHOE" title="Shoe-cognito">
                                                    <span>Shoe-cognito</span>
                                                    <!--<img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/>-->
                                                    <!--<span>Anonymous</span>-->
                                                </div>
                                            </div>
                                            <div class="liveImage" v-if="userList[2]">
                                                <div v-if="userList[2].isAnonymous === '0'">
                                                    <img :src="userList[2].picture" alt="USER-SHOE" :title="userList[2].firstName">
                                                    <span>{{userList[2].firstName}}</span>
                                                </div>
                                                <div v-else>
                                                    <img :src="userList[2].picture" alt="USER-SHOE" title="Shoe-cognito">
                                                    <span>Shoe-cognito</span>
                                                    <!--<img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/>-->
                                                    <!--<span>Anonymous</span>-->
                                                </div>
                                            </div>
                                            <div class="liveImage" v-if="userList[3]">
                                                <div v-if="userList[3].isAnonymous === '0'">
                                                    <img :src="userList[3].picture" alt="USER-SHOE" :title="userList[3].firstName">
                                                    <span>{{userList[3].firstName}}</span>
                                                </div>
                                                <div v-else>
                                                    <img :src="userList[3].picture" alt="USER-SHOE" title="Shoe-congnito">
                                                    <span>Shoe-cognito</span>
                                                    <!--<img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/>-->
                                                    <!--<span>Anonymous</span>-->
                                                </div>
                                            </div>
                                            <div class="liveImage" v-if="userList[4]">
                                                <div v-if="userList[4].isAnonymous === '0'">
                                                    <img :src="userList[4].picture" alt="USER-SHOE" :title="userList[4].firstName">
                                                    <span>{{userList[4].firstName}}</span>
                                                </div>
                                                <div v-else>
                                                    <img :src="userList[4].picture" alt="USER-SHOE" title="Shoe-cognito">
                                                    <span>Shoe-cognito</span>
                                                    <!--<img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/>-->
                                                    <!--<span>Anonymous</span>-->
                                                </div>
                                            </div>
                                            <div class="liveImage" v-if="userList[5]">
                                                <div v-if="userList[5].isAnonymous === '0'">
                                                    <img :src="userList[5].picture" alt="USER-SHOE" :title="userList[5].firstName">
                                                    <span>{{userList[5].firstName}}</span>
                                                </div>
                                                <div v-else>
                                                    <img :src="userList[5].picture" alt="USER-SHOE" title="Shoe-cognito">
                                                    <span>Shoe-cognito</span>
                                                    <!--<img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/>-->
                                                    <!--<span>Anonymous</span>-->
                                                </div>
                                            </div>
                                            <div class="liveImage" v-if="userList[6]">
                                                <div v-if="userList[6].isAnonymous === '0'">
                                                    <img :src="userList[6].picture" alt="USER-SHOE" :title="userList[6].firstName">
                                                    <span>{{userList[6].firstName}}</span>
                                                </div>
                                                <div v-else>
                                                    <img :src="userList[6].picture" alt="USER-SHOE" title="Shoe-cognito">
                                                    <span>Shoe-cognito</span>
                                                    <!--<img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/>-->
                                                    <!--<span>Anonymous</span>-->
                                                </div>
                                            </div>
                                            <div class="liveImage" v-if="userList[7]">
                                                <div v-if="userList[7].isAnonymous === '0'">
                                                    <img :src="userList[7].picture" alt="USER-SHOE" :title="userList[7].firstName">
                                                    <span>{{userList[7].firstName}}</span>
                                                </div>
                                                <div v-else>
                                                    <img :src="userList[7].picture" alt="USER-SHOE" title="Shoe-congnito">
                                                    <span>Shoe-cognito</span>
                                                    <!--<img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/>-->
                                                    <!--<span>Anonymous</span>-->
                                                </div>
                                            </div>
                                            <div class="liveImage" v-if="userList[8]">
                                                <div v-if="userList[8].isAnonymous === '0'">
                                                    <img :src="userList[8].picture" alt="USER-SHOE" :title="userList[8].firstName">
                                                    <span>{{userList[8].firstName}}</span>
                                                </div>
                                                <div v-else>
                                                    <img :src="userList[8].picture" alt="USER-SHOE" title="Shoe-congnito">
                                                    <span>Shoe-cognito</span>
                                                    <!--<img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/>-->
                                                    <!--<span>Anonymous</span>-->
                                                </div>
                                            </div>
                                            <div class="liveImage" v-if="userList[9]">
                                                <div v-if="userList[9].isAnonymous === '0'">
                                                    <img :src="userList[9].picture" alt="USER-SHOE" :title="userList[9].firstName">
                                                    <span>{{userList[9].firstName}}</span>
                                                </div>
                                                <div v-else>
                                                    <img :src="userList[9].picture" alt="USER-SHOE" title="Shoe-cognito">
                                                    <span>Shoe-cognito</span>
                                                    <!--<img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/>-->
                                                    <!--<span>Anonymous</span>-->
                                                </div>
                                            </div>
                                            <div class="liveImage" v-if="userList[10]">
                                                <div v-if="userList[10].isAnonymous === '0'">
                                                    <img :src="userList[10].picture" alt="USER-SHOE" :title="userList[10].firstName">
                                                    <span>{{userList[10].firstName}}</span>
                                                </div>
                                                <div v-else>
                                                    <img :src="userList[10].picture" alt="USER-SHOE" title="Shoe-congnito">
                                                    <span>Shoe-cognito</span>
                                                    <!--<img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/>-->
                                                    <!--<span>Anonymous</span>-->
                                                </div>
                                            </div>
                                            <div class="liveImage" v-if="userList[11]">
                                                <div v-if="userList[11].isAnonymous === '0'">
                                                    <img :src="userList[11].picture" alt="USER-SHOE" :title="userList[11].firstName">
                                                    <span>{{userList[11].firstName}}</span>
                                                </div>
                                                <div v-else>
                                                    <img :src="userList[11].picture" alt="USER-SHOE" title="Shoe-cognito">
                                                    <span>Shoe-cognito</span>
                                                    <!--<img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/>-->
                                                    <!--<span>Anonymous</span>-->
                                                </div>
                                            </div>
                                            <div class="liveImage" v-if="userList[12]">
                                                <div v-if="userList[12].isAnonymous === '0'">
                                                    <img :src="userList[12].picture" alt="USER-SHOE" :title="userList[12].firstName">
                                                    <span>{{userList[12].firstName}}</span>
                                                </div>
                                                <div v-else>
                                                    <img :src="userList[12].picture"alt="USER-SHOE" title="Shoe-cognito">
                                                    <span>Shoe-cognito</span>
                                                    <!--<img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/>-->
                                                    <!--<span>Anonymous</span>-->
                                                </div>
                                            </div>
                                            <div class="liveImage" v-if="userList[13]">
                                                <div v-if="userList[13].isAnonymous === '0'">
                                                    <img :src="userList[13].picture" alt="USER-SHOE" :title="userList[13].firstName">
                                                    <span>{{userList[13].firstName}}</span>
                                                </div>
                                                <div v-else>
                                                    <img :src="userList[13].picture" alt="USER-SHOE" title="Shoe-congnito">
                                                    <span>Shoe-cognito</span>
                                                    <!--<img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/>-->
                                                    <!--<span>Anonymous</span>-->
                                                </div>
                                            </div>
                                            <div class="liveImage" v-if="userList[14]">
                                                <div v-if="userList[14].isAnonymous === '0'">
                                                    <img :src="userList[14].picture" alt="USER-SHOE" :title="userList[14].firstName">
                                                    <span>{{userList[14].firstName}}</span>
                                                </div>
                                                <div v-else>
                                                    <img :src="userList[14].picture" alt="USER-SHOE" :title="Shoe-cognito">
                                                    <span>Shoe-cognito</span>
                                                    <!--<img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/>-->
                                                    <!--<span>Anonymous</span>-->
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <!--/////////////////////////// slider end here //////////////////////////////-->
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>
<!--                        <button class="btn-pink" @click="leaveEvent"><i class="fa fa-sign-out"></i>&nbsp;Leave</button>-->
                    </div>
                </div>
                <div class="aboutExpert">
                    <h2>about the expert</h2>
                    <img class="img-circle" :src="getExpert[0].small_image" :alt="getExpert[0].name" :title="getExpert[0].name">
                    <h4>{{getExpert[0].name}}</h4>
                    <span>{{getExpert[0].experties}}</span>
                    <p>
                        {{getSelectedEvent[0].longDescription}}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import $ from 'jquery'
    import slick from 'slick-carousel'

    export default {
        name: 'LiveEvent',
        metaInfo () {
            return {
                title: 'TONE | Live Event',
                meta: [
                    {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {property: 'og:title', content: 'TONE | Live Event'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'twitter:title', content: 'TONE | Live Event'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {
                        property: 'twitter:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                chatRollURL: '',
                eventUsersArray: [],
                eventUserArray: [],
                chatrllRef: '',
                jwEventRef: '',
                intervalId: '',
                seatReservation: {
                    userEventId: 0,
                    eventId: 0,
                    userId: 0,
                    status: 0,
                    isAnonymous: 0
                }
            }
        },
        methods: {
            create () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-slider-live')
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: false,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                })
            },
            leaveEvent () {
                this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {
                    if (this.getUserEvents) {
                        let uEvent = this.getUserEvents.filter(ev => {
                            return ev.eventId === this.getSelectedEvent[0].eventId
                        })
                        if (uEvent && uEvent.length > 0) {
                            this.seatReservation.eventId = this.getSelectedEvent[0].eventId
                            this.seatReservation.userId = this.user.userId
                            this.seatReservation.status = '1'
                            this.seatReservation.isAnonymous = '0'
                            this.seatReservation.userEventId = uEvent[0].userEventId
                            this.$store.dispatch('UPDATERESERVATION', this.seatReservation).then(() => {
                                this.$store.dispatch('LEAVEEVENT').then(() => {
                                    // this.$router.push('/')
                                })
                            })
                        }
                    }
                }, 300)
            },
            refreshAttendees () {
                if (this.getSelectedEvent) {
                    this.$store.dispatch('GETEVENTUSERS', this.getSelectedEvent[0].eventId).then(() => {
                        if (this.getEventUsers) {
                            this.eventUsersArray.splice(0, this.eventUsersArray.length)
                            $(this.$el).find('.responsive-slick-slider-live').slick('unslick')
                            // Divide Users into sub array
                            this.eventUserArray = this.getEventUsers
                            while (this.eventUserArray.length > 0) {
                                this.eventUsersArray.push(this.eventUserArray.splice(0, 15))
                            }
                            setTimeout(() => {
                                this.create()
                            }, 1000)
                        }
                    })
                }
            }
        },
        mounted: function () {
            /* create slider */
            let self = this
            if (self.getUnauthUserSignature) {
                if (this.$route.params.eventId > 0) {
                    this.$store.dispatch('GETSELECTEDEVENT', this.$route.params.eventId).then(() => {
                        if (this.getSelectedEvent) {
                            self.chatrllRef = this.getSelectedEvent[0].chatroll_event_name
                            console.log('user Status', self.getDemoUserStatus)
                            if (self.getDemoUserStatus === 1) {
                                console.info('cognito')
                                self.chatRollURL = `${self.getSelectedEvent[0].chatroll_event_name}?uid=1053&uname=Shoe-cognito&sig=${self.getUnauthUserSignature}&ismod=0&upic=https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg`
                            } else {
                                console.info('jane')
                                self.chatRollURL = `${self.getSelectedEvent[0].chatroll_event_name}?&uid=1053&uname=jane&sig=${self.getUnauthUserSignature}&ismod=0&upic=https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg`
                            }
                            console.log('chat roll user', self.chatRollURL)
                            this.jwEventRef = self.getSelectedEvent[0].jw_rtmp_url
                            this.$store.dispatch('GETEXPERT', this.getSelectedEvent[0].expertId).then(() => {
                            })
                            this.$store.dispatch('GETEVENTUSERS', this.getSelectedEvent[0].eventId).then(() => {
                                if (this.getEventUsers) {
                                    // Divide Users into sub array
                                    this.eventUserArray = this.getEventUsers
                                    while (this.eventUserArray.length > 0) {
                                        this.eventUsersArray.push(this.eventUserArray.splice(0, 15))
                                    }
                                    setTimeout(() => {
                                        this.create()
                                        window['intervalLive'] = setInterval(() => {
                                            this.refreshAttendees()
                                        }, 30000)
                                    }, 1000)
                                }
                            })
                        } else {
                            self.$router.push('/tone/demo/corporate-demo')
                        }
                    })
                } else {
                    self.$router.push('/tone/demo/corporate-demo')
                }
            } else {
                self.$router.push('/tone/demo/corporate-demo')
            }
            // if (self.getSelectedEvent) {
            //     console.info('found selected event')
            //     console.log('user status', self.getDemoUserStatus)
            //     if (self.getDemoUserStatus === 0) {
            //         self.chatRollURL = `${self.getSelectedEvent[0].chatroll_event_name}&uid=${Math.floor(Math.random() * 1000)}&uname=Jane&sig=${self.getUnauthUserSignature}&ismod=0&upic=https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg`
            //     } else {
            //         self.chatRollURL = `${self.getSelectedEvent[0].chatroll_event_name}&uid=${Math.floor(Math.random() * 1000)}&uname=Shoe-cognito&sig=${self.getUnauthUserSignature}&ismod=0&upic=https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg`
            //     }
            //     // this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {})
            // }
            // this.jwEventRef = self.getSelectedEvent[0].jw_rtmp_url
        },
        beforeDestroy () {
            // this.leaveEvent()
            clearInterval(window['intervalLive'])
        },
        computed: {
            ...mapGetters([
                'user', 'getExpert', 'getSelectedEvent', 'getUserEvents', 'getEventUsers', 'getUnauthUserSignature', 'getDemoUserStatus']
            )
        }
    }
</script>
<style scoped>
    @media(min-width:1200px){

        .liveEvent .col-md-offset-3.col-md-6 iframe {
        position:static !important;
        }
        .liveEvent .col-md-offset-3.col-md-6 {

            z-index: 20;
            position:relative;
            margin-bottom: 50px;
        }

        .attendees {
            position: relative;
            margin-top: 70px;
            left: 0;
            right: 0;
            z-index: 10;
        }

        .liveEvent {
            position: relative;
        }

        .liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage {
            width: 20%;
        }

        .liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage:nth-of-type(12), .liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage:nth-of-type(14) {
            /*margin-right: 60%;*/
        }

    }
</style>
<style>
    .liveEvent ul.slick-dots {
        display: none !important;
    }
    .btn-pink{
        margin: 10px auto;
        display: block;
        float: none;
    }
</style>



// WEBPACK FOOTER //
// LiveEventDemo.vue?c890c244